import { formatearFecha } from "../../../helpers/formatearFecha";

export const SEPARADOR_PERIODO = " - ";

export const esNulo = (valor) => valor === null || valor === undefined;

// Un punto por cierre con su periodo, para el eje X, y el valor de cada serie
// como número; los cierres sin el valor lo llevan en null
export const construirPuntosGrafica = (cierres, series) =>
    cierres.map((cierre) => {
        const punto = {
            periodo:
                formatearFecha(cierre.fecha_inicial) +
                SEPARADOR_PERIODO +
                formatearFecha(cierre.fecha_final),
        };

        series.forEach((serie) => {
            const valor = cierre[serie.dataKey];

            punto[serie.dataKey] = esNulo(valor) ? null : Number(valor);
        });

        return punto;
    });
